import Fade from '@mui/material/Fade'
import clsx from 'clsx'
import { ReactComponent as DropdownIcon } from 'images/icons/arrowSelect.svg'
import { useState } from 'react'

import { StyledDropdown } from './StyledDropdown'

import style from './Dropdown.module.css'

export interface IOption {
  value?: string | number
  text: string
  text2?: string | null
}

export interface IPropsDropdown {
  options: IOption[]
  currentOption?: IOption
  placeholder?: string
  disabled?: boolean
  onClickOption: (option: IOption) => void
  dataTestId?: string
  className?: string
  placeholderClassName?: string
  listClassName?: string
  description?: string
  children?: React.ReactNode
}

const Dropdown: React.FC<IPropsDropdown> = ({
  options,
  onClickOption = () => {},
  placeholder = '',
  currentOption = null,
  disabled = false,
  className,
  placeholderClassName,
  listClassName,
  description,
  children,
}) => {
  const [open, setOpen] = useState(false)
  const id = `${Math.random()}-dropdown`
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)

  const toggleOpen = () => {
    if (!disabled) {
      setOpen(prev => !prev)
    }
  }

  const handleClickDropdown = (event: React.MouseEvent<HTMLElement>) => {
    if (!disabled) {
      setAnchorEl(open ? null : event.currentTarget)
      toggleOpen()
    }
  }

  const handleClickOption = (option: IOption) => {
    if (!disabled) {
      toggleOpen()
      onClickOption(option)
    }
  }

  return (
    <>
      <div className={className}>
        {description && <div className={clsx('text-14-400', style.subtitle)}>{description}</div>}
        <div
          className={clsx(style.placeholder, { [style.placeholderDisabled]: disabled }, placeholderClassName)}
          onClick={handleClickDropdown}
          aria-controls={open ? id : undefined}
        >
          <div className={style.placeholderText}>
            {currentOption?.text ? currentOption.text : placeholder}
            {currentOption?.text2 && <div style={{ fontSize: '13px' }}>{currentOption.text2}</div>}
          </div>
          <div className={clsx(style.placeholderIcon, { [style.placeholderIconOpen]: open })}>
            <DropdownIcon />
          </div>
        </div>
      </div>
      <StyledDropdown
        className={listClassName}
        MenuListProps={{ 'aria-labelledby': id }}
        anchorEl={anchorEl}
        open={open}
        onClose={() => setOpen(false)}
        TransitionComponent={Fade}
      >
        {children}
        {options.map((option, index) => {
          const isActive = currentOption?.value === option.value
          return (
            <div
              key={index}
              onClick={() => handleClickOption(option)}
              className={clsx(style.dropdownItem, { [style.dropdownItemActive]: isActive })}
              data-value={option.value}
              style={{
                ...(anchorEl?.clientWidth && { width: `${anchorEl.clientWidth}px` }),
              }}
            >
              <div style={{}}>
                <span style={{}}>{option.text}</span>
                {option.text2 && <div style={{ fontSize: '12px' }}>{option.text2}</div>}
              </div>
            </div>
          )
        })}
      </StyledDropdown>
    </>
  )
}

export default Dropdown
